module.exports = __webpack_public_path__ + "static/media/kangaroo.8125809d.svg";